export default "__VITE_ASSET__C$eswmdq__"